module.exports = __webpack_public_path__ + "img/dep_babyfoodandcare.c913ce0f.png";